Controller = require 'controller'
Dates = require 'lib/dates'
OrganizationBoardsForMemberView = require 'views/organization/organization-boards-for-member-view'
RemoveGuestFromTeamBoardsView = require 'views/organization/remove-guest-from-team-boards'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'
localizeCount = require 'lib/localize-count'
getExperiment = require 'lib/experiments/simple-test'

module.exports = class MemberOrgActivityView extends View
  viewTitleKey: ->
    if getExperiment('teamMembersTabLayout').get('enabled')
      'team boards'
    else
      'org activity for member'

  viewTitleArguments: ->
    memberName: @model.get('fullName')

  initialize: ->
    @org = @options.org

  events:
    'click .js-view-org-boards-for-member': 'viewBoards'
    'click .js-view-member-org-cards': 'viewCards'
    'click .js-remove-guest-from-team-boards': 'removeGuestFromTeamBoards'

  render: ->
    data = @model.toJSON()
    data.teamMembersLayoutExperimentEnabled =
      getExperiment('teamMembersTabLayout').get 'enabled'

    data.isPremium = @org.isPremium()

    if data.teamMembersLayoutExperimentEnabled
      data.boards = @org.boardList.models
        .filter (board) =>
          _.contains(board.memberList.models, @model) && board.isOpen()
        .map (board) =>
          b = board.toJSON()
          b.memberType = l(['member types', board.getMemberType(@model)])
          b.url = board.getUrl()
          return b

      data.hasBoards = data.boards.length > 0
      data.canRemoveFromAllTeamBoards = @org.owned() && !@org.isMember(@model) && data.hasBoards
      data.teamBoardCount = data.boards.length

      if @org.isFeatureEnabled('orgCards')
        data.orgCardsUrl = Controller.getOrganizationMemberCardsUrl(
          @org.get('name'),
          data.username
        )

    else
      boardCount = 0

      for board in _.filter(@org.boardList.models, (board) => board.isOpen())
        if @model in board.memberList.models
          boardCount++

      data.boardCount = localizeCount('boards', boardCount)
      data.hasBoards = boardCount > 0

      if @org.isFeatureEnabled('orgCards')
        data.orgCardsUrl = Controller.getOrganizationMemberCardsUrl(
          @org.get('name'),
          data.username
        )

    @$el.html(
      templates.fill(
        'org_member_activity',
        data
      )
    )

    Dates.update(@el)

    @

  viewCards: ->
    track("Organization View", "Members Page", "Activity - View Org Cards")

  viewBoards: (e) ->
    Util.stop(e)
    track("Organization View", "Members Page", "Activity - View Boards")

    PopOver.pushView
      view: new OrganizationBoardsForMemberView({
        @model,
        parent: @org,
        @modelCache }
      )

    return

  removeGuestFromTeamBoards: (e) ->
    Util.stop(e)
    track("Organization View", "Members Page", "Activity - Remove From All Team Boards")

    teamBoardCount = parseInt(@$(e.target).closest('b').attr('data-teamboardcount'), 10)

    PopOver.pushView
      view: new RemoveGuestFromTeamBoardsView({
        @model,
        parent: @org,
        @modelCache,
        teamBoardCount }
      )

    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/member-org-activity-view.coffee